<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${purchasesPayment.code}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="purchasesPayment" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "purchasesPayment-view-logs",

  components: { LogListTable },

  props: ["purchasesPayment"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
